import { useContext, useEffect } from 'react';

import DateInputContext from 'contexts/DateInputContext';

// Pushes the chart's datasets into DateInputContext so the date-field picker and
// the "add filter" field list offer fields from the right datasets.
//
// This is a null-rendering child rather than a prop on DateInputProvider because
// the datasets are DERIVED from the chart def (via the metric cache) and change
// whenever the user reshapes the chart in the config rail —
// `initialDataTypes` is a one-shot seed and wouldn't track that. Same approach
// as ConfigureReportGadget.
const ExploreDataTypesSync = ({ dataTypes }: { dataTypes: string[] }) => {
  const { setDataTypes } = useContext(DateInputContext);

  useEffect(() => {
    setDataTypes(dataTypes);
  }, [dataTypes, setDataTypes]);

  return null;
};

export default ExploreDataTypesSync;
